module.exports = __webpack_public_path__ + "img/album10_14.6e63419e.jpg";